import React from 'react'
import { Plug, MessageCircle, Mail, ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import Button from '../../components/ui/Button'

const IntegracoesPage: React.FC = () => {
  const navigate = useNavigate()

  const integrations = [
    {
      id: 'whatsapp',
      name: 'WhatsApp',
      description: 'Configure a integração com WhatsApp Business para envio de mensagens automatizadas',
      icon: MessageCircle,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      borderColor: 'border-green-200',
      path: '/integracoes/whatsapp'
    },
    {
      id: 'email',
      name: 'Email',
      description: 'Configure o servidor SMTP para envio de emails e notificações',
      icon: Mail,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200',
      path: '/integracoes/email'
    }
  ]

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-white shadow-sm border-b px-6 py-4">
        <div className="flex items-center gap-4">
          <Plug className="h-8 w-8 text-purple-600" />
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Integrações</h1>
            <p className="text-gray-600">Configure as integrações com serviços externos</p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {integrations.map((integration) => {
            const Icon = integration.icon

            return (
              <div
                key={integration.id}
                className={`
                  ${integration.bgColor} ${integration.borderColor}
                  border rounded-lg p-6 hover:shadow-md transition-shadow
                `}
              >
                <div className="flex items-start justify-between">
                  <div className="flex items-center gap-4">
                    <div className="flex-shrink-0">
                      <Icon className={`h-10 w-10 ${integration.color}`} />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">
                        {integration.name}
                      </h3>
                      <p className="text-gray-600 text-sm mb-4">
                        {integration.description}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex justify-end">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => navigate(integration.path)}
                    rightIcon={<ArrowRight className="h-4 w-4" />}
                  >
                    Configurar
                  </Button>
                </div>
              </div>
            )
          })}
        </div>

        {/* Info */}
        <div className="mt-8 bg-gray-50 border border-gray-200 rounded-lg p-6">
          <div className="flex items-start gap-3">
            <Plug className="h-5 w-5 text-gray-500 mt-1" />
            <div>
              <h3 className="font-medium text-gray-900 mb-2">Sobre as Integrações</h3>
              <p className="text-gray-600 text-sm">
                As integrações permitem que o sistema se conecte com serviços externos para
                automatizar processos e melhorar a comunicação com os clientes. Configure
                cada integração conforme suas necessidades.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default IntegracoesPage